import { StyledDayPicker } from './DayPicker.styled';

export function DayPicker({ selectedDay, changeDay, className, show, limitByDates }) {

    if (typeof show !== 'undefined' && !show) {
        return null;
    }

    const maxDays = 31;

    const getDaysLimit = () => {
        let limit = maxDays;
        limitByDates.forEach(date => {
            const tmpDate = date instanceof Date ? date : new Date(date);
            tmpDate.setMonth(tmpDate.getMonth() + 1);
            tmpDate.setDate(0);
            const monthLimit = tmpDate.getDate();

            if (tmpDate.getDate() < limit) {
                limit = monthLimit;
            }
        })
        return limit;
    };

    const getDaysElems = () => {
      const result = [];
      const limit = limitByDates ? getDaysLimit() : maxDays;
      for (let i = 1; i <= limit; i++) {
          const className = selectedDay === i ? 'day active' : 'day';
          result.push(<div key={i} onClick={() => changeDay(i)} className={className}>{i}</div>);
      }
      return result;
    };

    return (
        <StyledDayPicker className={className}>
            <div className="content">
                {getDaysElems()}
            </div>
        </StyledDayPicker>
    )
}